import apiService from './api.service';

class FooterService {
  async getFooterSectionByUid(uid) {
    try {
      const response = await apiService.post('/sections/get-by-uid', { UID: uid }, {}, true);
      if (response && response.code === 1 && response.data) {
        const sectionData = Array.isArray(response.data) ? response.data[0] : response.data;
        
        // Filter out unpublished content
        if (sectionData && sectionData.IsPublished === false) {
          return {
            success: false,
            data: null,
            message: 'Footer section is not published',
          };
        }
        
        return {
          success: true,
          data: sectionData,
          message: response.message,
        };
      }
      
      return {
        success: false,
        data: null,
        message: response?.message || 'Failed to fetch footer section',
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.message || 'An error occurred while fetching footer section',
      };
    }
  }

  async getFooterTwo() {
    return this.getFooterSectionByUid('FOOTER-TWO');
  }

  async getFooterThree() {
    return this.getFooterSectionByUid('FOOTER-THREE');
  }

  async getFooterFour() {
    return this.getFooterSectionByUid('FOOTER-FOUR');
  }

  async getInternalLinks() {
    return this.getFooterSectionByUid('INTERNAL-LINKS');
  }

  async getImportantLinks() {
    return this.getFooterSectionByUid('IMPORTANT-LINKS');
  }

  async getAllFooterSections() {
    try {
      const [footerTwo, footerThree, footerFour, internalLinks, importantLinks] = await Promise.all([
        this.getFooterTwo(),
        this.getFooterThree(),
        this.getFooterFour(),
        this.getInternalLinks(),
        this.getImportantLinks()
      ]);

      return {
        footerTwo: footerTwo.success ? footerTwo.data : null,
        footerThree: footerThree.success ? footerThree.data : null,
        footerFour: footerFour.success ? footerFour.data : null,
        internalLinks: internalLinks.success ? internalLinks.data : null,
        importantLinks: importantLinks.success ? importantLinks.data : null
      };
    } catch (error) {
      return {
        footerTwo: null,
        footerThree: null,
        footerFour: null,
        internalLinks: null,
        importantLinks: null
      };
    }
  }

  /**
   * Get legal footer links (Sitemap, Privacy Policy, etc.) with IsPublished status
   * @returns {Promise<Object>} Response with legal links data
   */
 
async getLegalFooterLinks() {

  // ✅ Move this outside try so it's accessible everywhere
  const legalPages = [
    { id: 12, key: 'sitemap', route: '/sitemap', label: 'Sitemap' },
    { id: 13, key: 'privacyPolicy', route: '/privacy-policy', label: 'Privacy Policy' },
    { id: 14, key: 'termsAndConditions', route: '/terms-and-conditions', label: 'Terms and Conditions' },
    { id: 15, key: 'copyrightStatement', route: '/copyright-statement', label: 'Copy Right Statements' },
    { id: 16, key: 'disclaimer', route: '/disclaimer', label: 'Disclaimer' }
  ];

  try {

    const promises = legalPages.map(page =>
      apiService.post('/pages/get', { PageId: page.id })
        .then(response => ({
          ...page,
          isPublished: response?.data?.IsPublished || false
        }))
        .catch(() => ({
          ...page,
          isPublished: false
        }))
    );

    const results = await Promise.all(promises);

    const publishedPages = results.filter(page => page.isPublished);

    // ✅ If API returns published pages → show them
    if (publishedPages.length > 0) {
      return {
        success: true,
        data: publishedPages,
        message: 'Legal footer links fetched successfully'
      };
    }

    // ✅ Else fallback
    return {
      success: true,
      data: legalPages,
      message: 'No published pages found. Showing default legal links.'
    };

  } catch (error) {

    // ✅ If request completely fails → fallback
    return {
      success: true,
      data: legalPages,
      message: 'Failed to fetch from API. Showing default legal links.'
    };
  }
}


}

export default new FooterService();
